import { useI18n } from "@/i18n";
import { SectionShell } from "@/components/section-shell";

// Menü grubu: Menüler · Tema · Duyuru · Banner
// Bu dördü "müşterinin menü ekranında ne görür" sorusunun parçaları —
// tek başlık altında olmaları mental yükü azaltır.
export function MenuSection() {
  const { t } = useI18n();
  return (
    <SectionShell
      tabs={[
        { to: ".", label: t("menus"), end: true },
        { to: "themes", label: t("theme") },
        { to: "announcement", label: t("announcement") },
        { to: "banners", label: t("banners") },
      ]}
    />
  );
}
